import { api, getCurrentUser } from '@creditsights/api-ui-web';
import { EmailPreferences } from '../../models/EmailPreferences';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchEmailPreferences = async () => {
  const { userId } = getCurrentUser();
  const { data } = await api.get<EmailPreferences>(`profile/v1/profiles/${userId}/email-preferences`);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const saveEmailPreferences = async (preferences: EmailPreferences) => {
  const { userId } = getCurrentUser();
  const { data } = await api.patch<EmailPreferences>(`profile/v1/profiles/${userId}/email-preferences`, preferences);
  return data;
};
